module.exports = __webpack_public_path__ + "static/3-9150ac1ce1509a676623aa4c55d487a3.jpg";